import {
  LOG_IN,
  LOG_OUT,
  LOAD_USERS,
  UPDATE_QUESTIONS,
  UPDATE_ANSWERED,
} from "../actions/userActions";
import { loadUserState } from "../localStorage";

const initialState = loadUserState();

export const userReducer = (state:any = initialState, action:any) => {
  switch (action.type) {
    case LOG_IN:
      return {
        ...state,
        loggedUser: action.loggedUser,
      };
    case LOG_OUT:
      return {
        ...state,
        loggedUser: {},
      };

    case LOAD_USERS:
      return {
        ...state,
        users: action.users,
      };
    case UPDATE_ANSWERED:
      const [user1] = state.users.filter(
        (user:any) => user.id === action.info.author
      );
      user1.answers[action.info.questionId] = action.info.selectedOption;
      return { ...state, loggedUser: user1 };
    case UPDATE_QUESTIONS:
      const [user2] = state.users.filter(
        (user:any) => user.id === action.info.author
      );
      user2.questions.push(action.info.questionId);
      return { ...state };
    default:
      return { ...state };
  }
};
